/* eslint-disable react/no-danger */
import { useState, memo } from 'react';
import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@bwoty-web/ui-kit';
import './alternativeContentTabWrapper.scss';
import { updateUrlWithOpenHotelSection } from '../../../../utils/url';

const AlternativeContentTabWrapper = ({
  sectionKey,
  alternativeContent,
  labels,
  selectedSubSection,
}) => {
  const [selectedTab, setSelectedTab] = useState(selectedSubSection);

  if (!alternativeContent || !labels) {
    return null;
  }

  // to display tabs in the wanted order
  let alternativeContentSorted = alternativeContent;
  if (alternativeContentSorted.length > 1) {
    switch (sectionKey) {
      case 'foodAndBeverage':
        alternativeContentSorted = alternativeContent.sort((a, b) => {
          return b.name.localeCompare(a.name);
        });
        break;
      case 'kidsFacilities':
        alternativeContentSorted = alternativeContent.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        break;
      default:
    }
  }

  const tabs = alternativeContentSorted.map((ac) => labels[ac.name] || '');

  if (!tabs.length) {
    return null;
  }

  if (tabs.length === 1) {
    return (
      <div
        key={uniqid('alternative-content-html-')}
        className="gw-alternative-content-html"
        dangerouslySetInnerHTML={{ __html: alternativeContentSorted[0].html }}
      />
    );
  }

  return (
    <Tabs selectedIndex={selectedTab} defaultIndex={selectedTab}>
      <TabList>
        {tabs.map((tab) => (
          <Tab
            key={uniqid('alternative-content-tab-')}
            onClick={(i) => {
              updateUrlWithOpenHotelSection(`${sectionKey}:${i}`);
              setSelectedTab(i);
            }}
          >
            {tab}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {alternativeContentSorted.map((ac) => {
          if (ac.html) {
            return (
              <TabPanel key={uniqid('alternative-content-html-')}>
                <div
                  className="gw-alternative-content-html"
                  dangerouslySetInnerHTML={{ __html: ac.html }}
                />
              </TabPanel>
            );
          }
          return null;
        })}
      </TabPanels>
    </Tabs>
  );
};

AlternativeContentTabWrapper.propTypes = {
  sectionKey: PropTypes.string,
  alternativeContent: PropTypes.arrayOf(PropTypes.shape({})),
  labels: PropTypes.shape({}),
  selectedSubSection: PropTypes.number,
};

AlternativeContentTabWrapper.defaultProps = {
  sectionKey: '',
  alternativeContent: [],
  labels: null,
  selectedSubSection: 0,
};

const arePropsEqual = (oldProps, newProps) => {
  return (
    oldProps.sectionKey === newProps.sectionKey &&
    oldProps.selectedSubSection === newProps.selectedSubSection
  );
};

const MemoizedAlternativeContentTabWrapper = memo(
  AlternativeContentTabWrapper,
  arePropsEqual,
);

export default MemoizedAlternativeContentTabWrapper;
